module.exports = __webpack_public_path__ + "img/backpack.3177d8bd.svg";